<template>
  <div>
    <el-container class="px-3 mt-4" />
    <el-table :data="mvms" style="width: 100%" height="85vh">
      <el-table-column prop="AssetNo" label="機台編號" width="80" />
      <el-table-column prop="description" label="機台說明" />
      <el-table-column prop="client.name" label="客戶" />
      <el-table-column prop="locate.name" label="放置地址" />
      <el-table-column prop="model.name" label="型號" />
      <el-table-column prop="user.name" label="巡補員" />
      <el-table-column prop="Status" label="狀態">
        <template slot-scope="scope">
          <el-tag effect="dark" :type="scope.row.Status | statusColorFilter">
            <strong>
              {{ scope.row.Status | statusFilter }}
            </strong>
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="動作">
        <template v-if="scope.row.Status == 4" slot-scope="scope">
          <el-button size="small" @click="deploy(scope.row)">註冊</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer :visible.sync="drawer" :before-close="handleClose" :size="'90%'" direction="btt">
      <div class="text-center">
        <h1>請以QRCODE 掃描器掃描</h1>
        <qrcode-vue :value="mvm" level="H" size="300" margin="30" />
        <h3>uid: {{ uid }}</h3>
        <h3>機型: {{ model.name }}</h3>
        <el-button @click="drawer = false">關閉</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getMyMvms } from '@/api/ciruit';
import mvmSearch from '@/views/mvms/components/select.vue';
import QrcodeVue from 'qrcode.vue';
const methods = {
  async init() {
    this.mvms = await getMyMvms();
  },
  async deploy(mvm) {
    this.uid = mvm.uid;
    this.model = mvm.model;
    const ivm_api = `${process.env.VUE_APP_BASE_API}`.replace('/api', '/adminapi').replace('localhost:8000', 'localhost:8000');
    const setting = {
      ivm_api,
      uid: mvm.uid,
      wholesaler: mvm.wholesaler,
    };
    this.mvm = JSON.stringify(setting);

    this.drawer = true;
  },
  handleClose(done) {
    done();
  },
};
export default {
  components: {
    QrcodeVue,
    mvmSearch,
  },
  filters: {
    statusFilter(key) {
      const map = {
        1: '已註冊',
        2: '連線中',
        4: '未註冊',
      };
      return map[key] ? map[key] : '正常';
    },
    statusColorFilter(key) {
      const map = {
        1: 'success',
        2: 'danger',
        4: 'warning',
      };
      return map[key] ? map[key] : 'success';
    },
  },
  data() {
    return {
      mvms: [],
      drawer: false,
      mvm: null,
      uid: '',
      model: '',
      condition: {},
    };
  },
  created() {
    this.init();
  },
  methods,
};
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .offline {
  background: #fcbdbd;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
